import { gsap, ScrollTrigger, SplitText } from '../global/gsap';

const initAboutHero = (section) => {
    const pages = section.querySelectorAll('.js-page');
    const title = section.querySelector('.js-about-title');

    if (pages) {
        pages.forEach((page) => {
            const { rotate } = page.dataset;

            if (rotate) {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: page.parentElement,
                        start: 'top top',
                        end: 'bottom 25%',
                        scrub: 1.1,
                    },
                });

                tl.to(page, {
                    rotate,
                });
            }
        });
    }

    if (title) {
        const split = new SplitText(title, { type: 'chars,words' });

        gsap.set(split.chars, {
            yPercent: 100,
        });

        gsap.set(split.words, {
            overflow: 'hidden'
        });

        const titleTl = gsap.timeline({
            scrollTrigger: {
                trigger: title,
                start: 'top 80%',
            },
        });

        titleTl.to(split.chars, {
            yPercent: 0,
            stagger: 0.02,
            duration: 0.5,
            ease: 'power4.out',
        });
    }
};

export default initAboutHero;
